
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import { formatDate } from "@/javascript/formatDate"


import bus from '@/javascript/bus'

export default {
directives: {
TransferDom
},
components: {
Toast,
Previewer,
Actionsheet,
XDialog,

},
data () {
return {
minHeight: '',
fold: true,
more: true,
adjunctList: [],
detailsList: [],
resultList: [],
dealList: [],
dealAdjunct: [],
imgList: [],
showimgList: [],
show3: false,
menus: {
'title.noop': '<span>您确定撤销吗?</span>',
delete: '<span style="color:red" >撤销</span>'
},
showSuccess: false,
undoresult: [],
resultPic: false,
toast: {
text: '',
show: false
}
}
},
mounted () {
this.minHeight = document.documentElement.clientHeight;

this.initData()

},
methods: {
lookMore () {
this.fold = !this.fold
},
lookResult () {
this.more = !this.more
},
show: function (e) {
e = e || window.event
const target = e.target || e.srcElement
const showimgList = document.getElementsByClassName('deal-result')[0].querySelectorAll('img')

for (let i in showimgList) {
if (target === showimgList[i]) {
this.$refs.previewer.show(parseInt(i))
}
}
},
initData: function () {
/**
* 详情内容
*/
this.$http.get('/api/wtcp-complaints/public/complaints/' + this.$route.params.id + '?access_token=' + bus.userInfo.access_token).then((response) => {
console.log(response, "==");
this.adjunctList = response.data.data.attachementList
this.detailsList = response.data.data.complaints
this.dealList = response.data.data.complainAdvice
this.dealAdjunct = response.data.data.adviceAttachement
this.resultList = response.data.data.statusList
this.detailsList.createdDate = formatDate(this.detailsList.createdDate, 'yyyy年MM月dd日 hh:mm:ss')

this.adjunctList.forEach(item => {
if (item.fileType == 'image') {
this.imgList.push(item)
}
});

}).then(() => {
document.title = this.detailsList.principalName

const showimgList = document.getElementsByClassName('deal-result')[0].querySelectorAll('img')
const imgList2 = []
if (showimgList.length > 0) {
showimgList.forEach(item => {
imgList2.push({
src: item.src
})
})
this.showimgList = imgList2
}
})
},
rollBack (id) {
this.show3 = true
},
callPhone () {
window.location.href = 'tel://' + this.detailsList.principalTel
},
onDelete () {

this.$http.get('/api/wtcp-complaints/public/complaints/rollback/' + this.$route.params.id + '?access_token=' + bus.userInfo.access_token).then((response) => {
console.log(response.data.status, "status");
if (response.data.status === 1) {
this.imgList = []
this.toast.text = response.data.msg
this.toast.show = true
this.initData()
}

})
}
}
}
